import React, { type FC, useMemo } from 'react'
import { Helmet } from 'react-helmet'

import { objectEntries } from '../../../utils'

import { Translation } from '../../../domain'

import { useTranslator } from '../Internationalization'
import { useAppUsecase } from '../State'

export const Head: FC = () => {
    const translator = useTranslator()

    const getApplicationMetadataUsecase = useAppUsecase('getApplicationMetadataUsecase')

    const metadata = useMemo(() => getApplicationMetadataUsecase.invoke(), [getApplicationMetadataUsecase])

    return (
        <Helmet>
            <title>{translator.formatTranslation(Translation.APPLICATION_TITLE)}</title>
            {objectEntries(metadata).map(([name, value], k) => <meta key={k} httpEquiv={name} content={value} />)}
        </Helmet>
    )
}
